import i18n from "@/libs/i18n";
import { $themeColors } from "@themeConfig";
export const lineChartOptions = {
	chart: {
		type: "line",
		// Drag-to-select an x-range zooms in; the reset (home) button zooms back
		// out. `autoSelected: "zoom"` keeps the mouse in zoom mode even though the
		// zoom/pan/selection toolbar buttons are hidden below.
		zoom: {
			enabled: true,
			type: "x",
		},
		toolbar: {
			show: true,
			autoSelected: "zoom",
			tools: {
				download: false,
				selection: false,
				// The zoom tool must stay enabled for drag-to-select-range to work
				// (ApexCharts gates the drag behaviour on tools.zoom). Its magnifier
				// button is hidden via CSS so only the reset/home icon is visible.
				zoom: true,
				zoomin: false,
				zoomout: false,
				pan: false,
				reset: true,
			},
		},
	},
	tooltip: {
		x: {
			show: true,
			formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
				return `${i18n.t("Set")} ${value}`;
			},
		},
		y: {
			formatter: function(value) {
				if (value === null || value === undefined) return '';
				return Math.round(value);
			},
		},
	},
	colors: [
		$themeColors.primary,
		$themeColors.success,
		$themeColors.info,
		$themeColors.warning,
	],
	dataLabels: {
		enabled: true,
		dropShadow: { enabled: true, left: 2, top: 2, opacity: 0.5 },
		background: {
			enabled: true,
			foreColor: "#FFF",
			padding: 4,
			borderRadius: "100%",
			borderWidth: 1,
			borderColor: "#FFF",
			opacity: 0.75,
		},
		formatter: function(value) {
			if (value === null || value === undefined) return '';
			return Math.round(value);
		},
	},
	stroke: { curve: "smooth", width: 3 },
	// Very pale grey, solid grid lines so they stay behind the data.
	grid: {
		borderColor: "#ebe9f1",
		strokeDashArray: 0,
		yaxis: { lines: { show: true, color: "#ebe9f1" } },
	},
	xaxis: {
		labels: { show: true, style: { colors: $themeColors.secondary } },
		title: {
			text: i18n.t("Sets"),
			style: { color: $themeColors.secondary },
		},
	},
	yaxis: {
		min: -20,
		max: 120,
		tickAmount: 14,
		labels: {
			show: true,
			style: { colors: $themeColors.secondary },
			formatter: function(val) {
				if (val === null || val === undefined) return '';
				return Math.round(val);
			},
		},
	},
	legend: {
		itemMargin: { horizontal: 5 },
		position: "top",
		horizontalAlign: "left",
		show: true,
		labels: {
			colors: $themeColors.secondary,
		},
		onItemHover: { highlightDataSeries: true },
		onItemClick: { toggleDataSeries: true },
	},
	annotations: {
		position: "back",
		yaxis: [
			{ y: -20, y2: 0, fillColor: $themeColors.danger, opacity: 0.3 
				,label:{
					borderWidth: 0,
					text : i18n.t("Low Success"),
					textAnchor: "end",
					position: "right",
					offsetX: -50,
					offsetY:20,
					style: {
              background: $themeColors.danger,
              color: "#FFF",
              fontSize: '16px',
              fontWeight: 800,
              padding: {
                right: 50,
								bottom:10,
              },
          },
				}
			},
			{ y: 100, y2: 120, fillColor: $themeColors.success, opacity: 0.3
								,label:{
					borderWidth: 0,
					text : i18n.t("Great Success"),
					textAnchor: "end",
					position: "right",
					offsetX: -50,
					style: {
              background: $themeColors.success,
              color: "#FFF",
              fontSize: '16px',
              fontWeight: 800,
              padding: {
                right: 50,
              },
          },
				}
			 },
			{
				y: 0,
				borderColor: $themeColors.danger,
				borderWidth: 2,
				strokeDashArray: 0,
			},
			// 	{
			// 		y: 20,
			// 		borderColor: $themeColors.warning,
			// 		borderWidth: 2,
			// 		strokeDashArray: 0,
			// 		label: {
			// 			borderColor: $themeColors.warning,
			// 			borderWidth: 2,
			// 			style: { background: $themeColors.warning, color: "#FFFFFF" },
			// 			text: "E",
			// 			offsetX: -20,
			// 			offsetY: 35,
			// 		},
			// 	},
			// 	{
			// 		y: 40,
			// 		borderColor: $themeColors.info,
			// 		borderWidth: 2,
			// 		strokeDashArray: 0,
			// 		label: {
			// 			borderColor: $themeColors.info,
			// 			borderWidth: 2,
			// 			style: { background: $themeColors.info, color: "#FFFFFF" },
			// 			text: "C",
			// 			offsetX: -20,
			// 			offsetY: -20,
			// 		},
			// 	},
			// 	{
			// 		y: 40,
			// 		borderWidth: 0,
			// 		strokeDashArray: 0,
			// 		label: {
			// 			borderColor: $themeColors.info,
			// 			borderWidth: 2,
			// 			style: { background: $themeColors.info, color: "#FFFFFF" },
			// 			text: "D",
			// 			offsetX: -20,
			// 			offsetY: 35,
			// 		},
			// 	},
			// 	{
			// 		y: 60,
			// 		borderColor: $themeColors.info,
			// 		borderWidth: 2,
			// 		strokeDashArray: 0,
			// 		label: {
			// 			borderColor: $themeColors.success,
			// 			borderWidth: 2,
			// 			style: { background: $themeColors.success, color: "#FFFFFF" },
			// 			text: "B",
			// 			offsetX: -20,
			// 			offsetY: -20,
			// 		},
			// 	},
			// 	{
			// 		y: 80,
			// 		borderColor: $themeColors.success,
			// 		borderWidth: 2,
			// 		strokeDashArray: 0,
			// 		label: {
			// 			borderColor: $themeColors.success,
			// 			borderWidth: 2,
			// 			style: { background: $themeColors.success, color: "#FFFFFF" },
			//      text: "A",
			// 			offsetX: -20,
			// 			offsetY: -20,
			// 		},
			// 	},
			{
				y: 100,
				borderColor: $themeColors.success,
				borderWidth: 2,
				strokeDashArray: 0,
			},
		],
	},
};
